import { toast } from 'react-toastify';
import appApi from '../../../../../api/app-api';
import { displayErrorText } from '../../../../../api/errors/api-error-codes';
import { CheckBounceReasonDetailsEntity } from '../../../../../api/types/settings/bouncing-check-reasons/bouncing-check-reasons.type';

export const getCheckBounceReasonsListOperation = async (
  offset: number,
  limit: number,
  setData: (data: CheckBounceReasonDetailsEntity[]) => void,
  setTotal: (total: number) => void,
  setLoading: (loading: boolean) => void,
) => {
  try {
    setLoading(true);

    const res = await appApi.getCheckBounceReasonsList({ offset, limit });

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return;
    }

    setData(res.data.body?.data ?? []);
    setTotal(res.data.body?.total ?? 0);
    setLoading(false);
  } catch (e) {
    console.error(`getCheckBounceReasonsListOperation failed with error: ${e}`);
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
    setLoading(false);
  }
};
